import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { ValidationError } from "../api/api";
import type { FlowCard, TextContent } from "../api/dto/FlowCard";
import { useDisplayLanguage } from "../components/cardFlowEditor/CardContentPreview";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Input, Select } from "@ventumsoftware/react-toolkit";

// Basic — creates an empty card (no content blocks/actions yet, that editor doesn't exist yet) just
// with a type and a column/position so it shows up in the right place on the canvas.
export const AddCardModal: FC<{
  column: number;
  posInColumn: number;
  createCard: (
    name: TextContent,
    cardType: string,
    column: number,
    positionInColumn: number,
  ) => Promise<FlowCard>;
  cardTypeOptions: Record<string, string>;
  onCreated: (card: FlowCard) => void;
}> = (props) => {
  const displayLanguage = useDisplayLanguage();
  const [name, setName] = useState<string>("");
  const [cardType, setCardType] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    const card = await props
      .createCard({ [displayLanguage]: name }, cardType, props.column, props.posInColumn)
      .catch((e) => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat());
        }
        throw e;
      });
    props.onCreated(card);
  };

  return (
    <div className={"flex flex-col space-y-4"}>
      <div>
        <Input type={"text"} focus label={"Naam"} value={name} onChange={setName} />
      </div>
      <div>
        <Select
          label={"Type"}
          options={{ "": "Kies een type", ...props.cardTypeOptions }}
          value={cardType}
          onChange={setCardType}
        />
      </div>
      {errors.length > 0 && (
        <div className={"text-red-600 text-sm"}>
          {errors.map((error) => (
            <div key={error}>{error}</div>
          ))}
        </div>
      )}
      <ModalFooter text={"Opslaan"} icon={faSave} onSubmit={save} disabled={!name || !cardType} />
    </div>
  );
};
